import { featureToggles } from '~/App/config/featureToggles';

export const featureIsEnabled = (feature) => {
  return featureToggles[feature];
};
